import { render, staticRenderFns } from "./FormInputIcon.vue?vue&type=template&id=36cf1fe4&"
import script from "./FormInputIcon.vue?vue&type=script&lang=js&"
export * from "./FormInputIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/production/spf-sexosafe-ezplatform/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36cf1fe4')) {
      api.createRecord('36cf1fe4', component.options)
    } else {
      api.reload('36cf1fe4', component.options)
    }
    module.hot.accept("./FormInputIcon.vue?vue&type=template&id=36cf1fe4&", function () {
      api.rerender('36cf1fe4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/TestForm/components/FormInputIcon/FormInputIcon.vue"
export default component.exports